import React, { useState, useEffect } from 'react'
import { SketchPicker } from "react-color";

const ColorPicker = ({ setValues, values, value }) => {
  const [colorRGBA, setcolorRGBA] = useState("rgba(247, 204, 83, 1)");
  const [display_RGBA, setdisplay_RGBA] = useState(false);

  useEffect(() => {
    if (values.color_code) {
      let hex = values.color_code.replace(/^#/, '');
      if (hex.length === 3) {
        hex = hex.split('').map(char => char + char).join('');
      }
      const bigint = parseInt(hex, 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      const alpha = 1; 

       const updatedColor = `rgba(${r}, ${g}, ${b}, ${alpha})`;
      setcolorRGBA(updatedColor);
    }
  }, [values.color_code]);

  function handleRGBA() {
    setdisplay_RGBA(!display_RGBA);
  }

  const onSwatchHover_RGBA = (color) => {
   
    const format =
      "rgba(" +
      color.rgb.r +
      "," +
      color.rgb.g +
      "," +
      color.rgb.b +
      "," +
      color.rgb.a +
      ")";
    setcolorRGBA(format);
    setValues({
      ...values,
      color_code: color.hex
    })
  };

  return (
    <React.Fragment>
      <div className="nano-colorpicker" onClick={handleRGBA}>
        <i
          style={{
            height: "28px",
            width: "28px",
            background: colorRGBA,
            display: "block",
            border: '1px solid grey'
          }}
        />
      </div>
      {display_RGBA ? (
        <SketchPicker
          color="#fff"
          value={colorRGBA}
          width="160px"
          onChangeComplete={onSwatchHover_RGBA}
        />
      ) : null}
    </React.Fragment>
  )
}

export default ColorPicker
